if (!customElements.get('bewo-poltrona-bastidores')) {
  class BewoPoltronaBastidores extends HTMLElement {
    connectedCallback() {
      this.scroller = this.querySelector('[data-bastidores-scroller]');
      this.moreBtn = this.querySelector('[data-bastidores-more]');

      this.initLightbox();
      this.initScrollHint();
    }

    disconnectedCallback() {
      if (this.lightbox) {
        this.lightbox.destroy();
        this.lightbox = null;
      }

      if (this.scroller && this.onScroll) {
        this.scroller.removeEventListener('scroll', this.onScroll);
      }
      if (this.moreBtn && this.onMoreClick) {
        this.moreBtn.removeEventListener('click', this.onMoreClick);
      }
      if (this.onResize) {
        window.removeEventListener('resize', this.onResize);
      }
    }

    initLightbox() {
      if (this.lightbox || this.dataset.lightbox !== 'true') return;

      const start = () => {
        if (!window.BewoTheme?.PhotoSwipeLightbox || !window.BewoTheme?.PhotoSwipe) {
          return false;
        }

        this.lightbox = new window.BewoTheme.PhotoSwipeLightbox({
          gallery: this,
          children: 'a[data-pswp-src]',
          pswpModule: window.BewoTheme.PhotoSwipe,
          bgOpacity: 0.92,
          padding: { top: 24, bottom: 24, left: 16, right: 16 },
        });

        this.lightbox.init();
        return true;
      };

      if (start()) return;

      let tries = 0;
      const timer = setInterval(() => {
        tries += 1;
        if (start() || tries > 40) clearInterval(timer);
      }, 100);
    }

    initScrollHint() {
      if (!this.scroller || !this.moreBtn) return;

      this.onScroll = () => this.updateScrollHint();
      this.onMoreClick = () => {
        const step = Math.max(this.scroller.clientHeight * 0.78, 240);
        this.scroller.scrollBy({ top: step, behavior: 'smooth' });
      };
      this.onResize = () => this.updateScrollHint();

      this.scroller.addEventListener('scroll', this.onScroll, { passive: true });
      this.moreBtn.addEventListener('click', this.onMoreClick);
      window.addEventListener('resize', this.onResize, { passive: true });

      requestAnimationFrame(() => this.updateScrollHint());
    }

    updateScrollHint() {
      if (!this.scroller || !this.moreBtn) return;

      const maxScroll = this.scroller.scrollHeight - this.scroller.clientHeight;
      const canScroll = maxScroll > 12;
      const nearBottom = this.scroller.scrollTop >= maxScroll - 16;

      this.classList.toggle('has-more', canScroll && !nearBottom);
      this.moreBtn.hidden = !canScroll;
      this.moreBtn.setAttribute('aria-hidden', canScroll && !nearBottom ? 'false' : 'true');
      this.moreBtn.tabIndex = canScroll && !nearBottom ? 0 : -1;
      this.moreBtn.classList.toggle('is-visible', canScroll && !nearBottom);
    }
  }

  customElements.define('bewo-poltrona-bastidores', BewoPoltronaBastidores);
}
